import FamilyLogo from "../FamilyLogo";

/** Contenitore delle pagine pubbliche di accesso Family (stesso aspetto di login e attivazione invito). */
export default function FamilyAuthShell({ children }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#f7f5fb] px-4 py-10 text-[#3D2868]">
      <div className="w-full max-w-[420px]">
        <div className="mb-8 flex justify-center"><FamilyLogo className="mx-auto h-14" /></div>
        <section className="rounded-[1.6rem] border border-white/80 bg-white p-6 shadow-[0_24px_70px_rgba(110,72,181,0.08)] sm:p-8">{children}</section>
      </div>
    </div>
  );
}

export function errorDetail(payload, fallback) {
  const detail = payload?.detail;
  if (Array.isArray(detail)) return detail.map((item) => item.msg || item).join(" ");
  return typeof detail === "string" && detail ? detail : fallback;
}
